import React, { useContext } from 'react'
import { AuthContext } from '../App'
import '../style/Admin.scss'

export default function Admin() {
    const { user, handleLogout, setIsModalOpen } = useContext(AuthContext)

    return (
        <div className="admin-wrapper">
            {!user ? (
                <button onClick={() => setIsModalOpen(true)} className="open-login-btn">
                    <span>🔑</span> Մուտք
                </button>
            ) : (
                <div className="admin-logged-in">

                    <button onClick={handleLogout} className="logout-btn">
                        Ելք
                    </button>
                </div>
            )}
        </div>
    )
}